<template>
  <div class="orgout"
    id="orgout"
    v-on:scroll.passive="handleScroll">
    <!-- -->
    <div class="org-main"
      :class="{'pad-top':isFixed}">

      <div id="title-fixed"
        v-if="isFixed"
        class="title-fixed">
        <span v-if="isFixed"
          class="iconfont iconarrowleft-fill icon-back-fixed"
          :style="{'opacity': opacity}"
          @click="back"></span>
        <span :style="{'opacity': opacity}"
          class="fix-content"
          style="line-height:42px;">
          {{data.name }}
        </span>
      </div>

      <div class="top"
        v-if="!isFixed">
        <img class="img-back"
          src="~@assets/imgs/back.png"
          alt=""
          @click="back" />
      </div>
      <div class="org-info"
        id="org-info">
        <div class="org-logo">
          <div v-if="!isFixed"
            class="title"
            id="title">
            <span class="name"
              v-text="data.name"></span>

            <span v-if="!isMarked"
              class="mark not-marked add-button"
              @click="mark">
              + 收藏
            </span>
            <span v-if="isMarked"
              class="mark marked add-button"
              @click="mark">
              已收藏
            </span>
            <span class="add-relation"
              @click="goToAddRelationshipPage">+ 关系</span>
          </div>
        </div>

        <div class="desc">
          {{data.description}}
        </div>
        <div class="tags">
          <van-tag v-for="industry in industryFieldArr"
            :key="industry"
            plain
            type="primary"
            class="my-tag">
            {{ industry }}
          </van-tag>
        </div>
        <div>
          <!-- {{num}} -->
        </div>
      </div>
      <div class="tabs">
        <van-tabs v-model="active"
          style="height: 100%"
          sticky
          offset-top="64px">
          <van-tab title="机构团队">
            <form action=""
              style="width:100%">
              <van-search v-model="memberSearch"
                placeholder="请输入姓名进行搜索"
                style="flex: 1;"
                @clear="onMemberSearch"
                @search="onMemberSearch"
                @blur="onMemberSearch" />
            </form>
            <member-list :member-list="memberList"
              :org-id="orgId"
              member-type="org"
              id='org-member'></member-list>
          </van-tab>
          <van-tab title="已投公司">
            <form action=""
              style="width:100%">
              <van-search v-model="companySearch"
                placeholder="请输入关键字进行搜索"
                style="flex: 1;"
                @clear="onCompanySearch"
                @search="onCompanySearch" />
            </form>
            <org-invested ref="comp"
              :related-id="data.apiID"
              id='org-invested'></org-invested>
          </van-tab>
          <van-tab title="机构活动">
            <org-events :data="data"
              id='org-events'></org-events>
          </van-tab>
          <van-tab title="相关资讯">
            <related-news :data-type="dataType"
              :related-id="data.apiID"
              id='org-related'></related-news>
          </van-tab>
        </van-tabs>
      </div>
    </div>

    <van-overlay :show="showOverlay">
      <div class="wrapper"
        @click.stop>
        <van-loading class="" />
      </div>
    </van-overlay>

  </div>
</template>

<script>
import common from "@common/common";
import webService from "@network/webService";
import _ from "lodash";
import scollerLocation from "@/common/scollerLocation";
import MemberList from "@components/content/invested/MemberList";
import OrgInvested from "@components/content/org/OrgInvested";
import OrgEvents from "@components/content/org/OrgEvents";
import RelatedNews from "@components/content/invested/RelatedNews";

export default {
  data () {
    return {
      num: 0,
      showOverlay: false,
      ofTop: 0,
      titleHeight: 0,
      isFixed: false,
      opacity: 1,
      isMarked: false,
      buttonDisabled: false,
      dataType: common.relationshipSearchTypeEnum.PEOrganization,

      data: {},
      contacts: [],
      active: 0,
      order: 0,
      orderOptions: [
        { text: "按职能排序", value: 0 },
        { text: "按级别排序", value: 1 },
      ],
      investmentEvents: [],
      orgId: "",
      memberSearch: "",
      memberList: [],
      companySearch: "",
    };
  },
  components: {
    MemberList,
    OrgInvested,
    OrgEvents,
    RelatedNews,
  },
  computed: {
    industryFieldArr () {
      // debugger;
      if (this.data.favoriteField) {
        return _.split(this.data.favoriteField, ",", 6);
      } else {
        return [];
      }
    },
  },
  activated () {
    this.isFixed = false;
    scollerLocation.recoverLocation("orgout");
  },
  beforeRouteLeave (to, from, next) {
    var orgMemberList = document.querySelector("#orgout");
    if (orgMemberList) {
      scollerLocation.saveLocation("orgout", orgMemberList);
    }
    next();
  },
  created () { },
  mounted () {
    this.$bus.$on("busfreshOrg", ({ orgId }) => {
      this.init(orgId);
    });
    this.init(this.$route.query.id);
  },
  methods: {
    init (orgId) {
      console.log("id", orgId);
      this.orgId = orgId;
      this.showOverlay = true;
      webService.getPEDetails(orgId).then((res) => {
        console.log("contacts:", res.data.contacts);
        this.data = res.data;
        this.memberList = this.data.contacts;
        this.isMarked = res.data.marked;
        this.showOverlay = false;
      });

      let orginfo = document.getElementById("org-info");
      if (orginfo) {
        this.ofTop = orginfo.offsetTop;
        console.log("this.ofTop: " + this.ofTop);
      }

      common.addViewHistory(
        orgId,
        common.favoriteTypeEnum.Organization
      );
    },
    handleScroll () {
      let scrollTop = document.getElementById("orgout").scrollTop;
      let orginfo = document.getElementById("org-info");
      if (orginfo) {
        this.ofTop = orginfo.offsetTop;
        // console.log("this.ofTop: " + this.ofTop);
        if (this.isFixed) {
          this.ofTop = this.ofTop - 54;
        }
      }
      let mainH =
        document.getElementsByClassName("org-main")[0].offsetHeight;
      let viewH = document.body.offsetHeight;
      let diff = mainH - viewH;
      // console.log(scrollTop, diff);
      if (scrollTop >= diff && this.active == 1) {
        //手动加载投资公司下一页数据
        this.$refs.comp.nextPage();
      }
      //获取标题元素高度
      let title = document.getElementById("title");
      // debugger;
      if (title) {
        this.titleHeight = title.offsetHeight;
      }

      //获取标题距离页面偏移高度
      // console.log("scrollTop:" + scrollTop);
      // console.log("ofTop:" + this.ofTop);
      //   console.log("scrollTop:" + scrollTop, "ofTop: " + this.ofTop);
      //去掉固定top 的高度，用于滚动实际计算
      let calcH = this.ofTop;
      let opc = 0;
      //滚动高度大于实际计算的偏移高度之后，需要开始显示固定bar
      if (scrollTop >= calcH) {
        //继续滚动的时候，计算超出实际计算的高度，并计算占有实际 title 高度的百分比
        opc = ((scrollTop - calcH) * 1.0) / this.titleHeight;
        // opc = 1;
        this.opacity = opc;
        // console.log("opc", opc);
      }
      //百分比小于0之后，表明需要隐藏 固定bar
      if (opc <= 0) {
        this.isFixed = false;
      } else {
        //有透明度，表示需要显示 固定bar
        this.isFixed = true;
      }
    },
    changeOrder (val) {
      console.log("order", val);
      if (val == 0) {
        //responsibility
        this.contacts = _.orderBy(
          this.contacts,
          ["responsibilityId"],
          ["desc"]
        );
      } else if (val == 1) {
        //title
        this.contacts = _.orderBy(this.contacts, ["titleId"], ["asc"]);
      }
    },
    goToAddRelationshipPage () {
      let orgData = {
        apiID: this.data.apiID,
        id: this.data.id,
        index: 1,
        name: this.data.name,
      };
      this.$router.push({
        path: "/home/addRelationship",
        query: {
          orgData: orgData,
        },
      });
    },
    goToContectDetails (contact) {
      this.$router.push({
        path: "/contractorDetail",
        query: {
          id: contact.id,
        },
      });
    },
    goCompany (id) {
      this.$router.push({
        path: "/investedDetail/" + Math.random() * 1000000,
        query: {
          id: id,
        },
      });
      webService.getContactsByPEVCId(this.$route.query.id).then((res) => {
        this.contacts = _.filter(res.data, function (m) {
          return m.passed == true;
        });
      });
    },
    mark () {
      common.mark(
        this,
        this.$route.query.id,
        common.favoriteTypeEnum.Organization,
        this.isMarked
      );
    },
    back () {
      this.$router.go(-1);
    },
    onMemberSearch () {
      if (_.trim(this.memberSearch).length > 0) {
        this.memberList = _.filter(this.data.contacts, (m) => {
          return (
            m.name
              .toLowerCase()
              .indexOf(this.memberSearch.toLowerCase()) >= 0
          );
        });
      } else {
        this.memberList = this.data.contacts;
      }
      console.log("this.memberList ", this.memberList);
    },
    onCompanySearch () {
      this.$refs.comp.search(this.companySearch);
    },
  },
};
</script>

<style lang="scss" scoped>
.orgout {
  height: 100%;
  overflow: auto;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.add-relation {
  position: absolute;
  width: 45px;
  height: 30px;
  line-height: 30px;
  right: 55px;
  bottom: 0;
  padding: 0 0.375rem;
  text-align: center;
  color: white;
  background-color: #d04a02;
  font-size: 14px;
}
.add-button {
  font-size: 14px;
  right: -15px;
  width: 45px;
}
.org-main {
  display: flex;
  flex-direction: column;
  .top {
    flex-shrink: 0;
    padding: 0.625rem 1.625rem;
    background-color: #d04a02;
    height: 35px;
    display: flex;
    align-items: center;
    .img-back {
      width: 2.5rem;
      height: 2.5rem;
    }
  }
  .org-info {
    padding: 0.625rem 1.625rem;
    .org-logo {
      //   position: relative;
      //   height: 2.875rem;
      .img-logo {
        position: absolute;
        top: -2.5rem;
        height: 4.375rem;
        width: 4.375rem;
      }
      .title {
        position: relative;
        margin-bottom: 10px;
        .name {
          font-size: 1.625rem;
          font-weight: bolder;
          display: flex;
          max-width: 60%;
        }
      }
    }
    .desc {
      font-size: 12px;
      color: #7d7d7d;
      line-height: 22.5px;
    }

    .tags {
      margin-top: 10px;
      .my-tag {
        background-color: #f7f7f7;
        color: #464646;
        padding: 4px;
        margin: 0px 5px 0px 0px;
        font-size: 0.75rem;
      }

      .my-tag::before {
        border: none;
      }
    }
  }
  .tabs {
    flex: 1;
    width: 100%;
    overflow: hidden;
  }
}
/deep/ .van-tabs__wrap {
  border-bottom: 1px solid #dedede;
}
/deep/ .van-tabs__content {
  // height: calc(100% - 44px);
  height: 100%;
  overflow: auto;
}
/deep/ .van-tab__pane {
  height: 100%;
}

.title-fixed {
  position: absolute;
  top: 0;
  color: #fff;
  background-color: #d04a02;
  font-size: 16px;
  margin: 0 auto;
  width: calc(100% - 10px); // padding: 10px 0px 0px 50px;
  padding-top: 10px;
  padding-left: 10px;
  height: 54px;

  z-index: 999999;

  .fix-content {
    margin-left: 30px;
  }
}
.pad-top {
  padding-top: 110px;
}
.tab-fixed {
  // height: 100%;
  position: fixed;
  top: 64px;
  background-color: #fff;
}
.icon-back-fixed {
  // display: inline-block;
  position: absolute;
  // left: 14px;
  top: 18px;
  color: #fff;
  z-index: 999;
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/content/org/OrgDetail.vue